import React, { useState, useEffect, Fragment, useRef } from 'react'
import { Table, Modal, message, Divider, Button } from "antd";
import { DownloadOutlined, PlusOutlined, EditFilled, DeleteOutlined } from '@ant-design/icons';
import StationApi from '@api/station'
import RoleApi from '@api/role'
import SearchForm from '@components/SearchForm'
import HandleButton from '@components/HandleButton'
import Title from '@/components/Title'
import { connect } from 'react-redux'
import moment from 'moment';
import { setStateSearchParams } from '@store/actions/common'
import AddModel from './add'
import '../station/style.css'

const RoleCom = ({ history, userInfo, searchArgs, dispatch }) => {
  const [loading, setLoading] = useState(false)
  const [loadBtn, setLoadBtn] = useState(false)
  const [data, setData] = useState([]) // 表格数据
  const [deleteVisible, setDelVisible] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [totalData, setTotalData] = useState({})
  const [editTitle, setEditTitle] = useState('新建角色')
  const [rowParams, setRowParams] = useState()
  const [roleText, setRoleText] = useState([])
  // 查询参数
  // const [name, setName] = useState()
  const [name, setName] = useState()
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    name: ''
  })
  const [total, setTotal] = useState(0)


  // 搜索
  const [inputList] = useState([{
    label: '角色名称:',
    name: "name",
    message: "请输入角色名称",
    span: 8,
    labelCol: 6
  }])
  const [selectList] = useState([
    {
      label: '角色类型:',
      name: "roleType",
      message: "请选择角色类型",
      options: [{ title: '用户', value: 1, checked: false }, { title: '运维', value: 2, checked: false }],
      span: 8,
      labelCol: 6
    }
  ])

  useEffect(() => {
    listByRole()
    RoleApi.getDictByType("role_type").then(res =>{
      setRoleText(res.data)
    })
    return () => { }
  }, [searchParams])

  const listByRole = () => {
    setLoading(true)
    RoleApi.query({ ...searchParams, }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setData(res.data?.data)
        setTotal(res.data?.total)
      }
    })
  }

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
    }
    setSearchParams(params)
  }

  /**
  * 删除规则
  */
  const deletes = () => {
    setLoadBtn(true)
    RoleApi.delete({ id: rowParams.id }).then(res => {
      setLoadBtn(false)
      if (res.status == 0) {
        setDelVisible(false)
        setRowParams(null)
        listByRole()
        message.success("删除成功！")
      }
    }).catch(err => {
      setLoadBtn(false)
    })
  }

  const cancel = () => {
    setDelVisible(false)
    // setParams({})
  }

  const btnList = [{
    title: "新增",
    type: 'primary',
    icon: <PlusOutlined />,
    visible: true,
    onClick: () => {
      setEditVisible(true)
      setRowParams(null)
    }
  }]

  const columns = [
    {
      title: '角色ID',
      dataIndex: 'id',
      align: 'center',
      key: 'id',
      width: 180
    },
    {
      title: '角色名称',
      dataIndex: 'name',
      align: 'center',
      key: 'name',
      width: 180
    },
    {
      title: '创建人',
      dataIndex: 'createName',
      align: 'center',
      key: 'createName',
      width: 150,

    },
    {
      title: '创建时间',
      dataIndex: 'createAt',
      align: 'center',
      key: 'rive',
      width: 220,
      render: (obj) => {
        if (obj) {
          return (
            moment(obj).format('YYYY-MM-DD HH:mm:ss')
          )
        }
      }
    },
    {
      title: '操作',
      key: 'operation',
      width: 220,
      render: (obj, record) => {
        return (
          // <HandleButton btnList={tabBtnList} obj />
          <div >
            <Button
              style={{ fontSize: '12px' }}
              onClick={() => {   
                RoleApi.getRoleInfoById({roleId: record.id}).then(res => {
                  if ( res.status !== '0' ) return
                  setRowParams(res.data)
                  setEditTitle('编辑角色')
                  setEditVisible(true)
                })
              }
              }
              size='samll'
              icon={<EditFilled />}
              type='primary'>编辑
            </Button>
            <Button
              style={{ fontSize: '12px', marginLeft: '5px' }}
              onClick={() => {
                setDelVisible(true)
                setRowParams(record)
              }
              }
              size='samll'
              icon={<DeleteOutlined />}
              type='primary'>删除
            </Button>
          </div>
        )
      }
    }
  ]
  return (
    <div className='baseContent boundary'>
      <div className='title'>
        {/* <Title title="站点列表" style={{ marginLeft: '24px' }}></Title> */}
        <div style={{ marginLeft: '24px' }}>
          <SearchForm searchParams={searchParams} span={6} inputList={inputList} selectList={selectList} onSearch={search} />
        </div>
        <HandleButton btnList={btnList} btnStyle={{ padding: '0 24px 20px', textAlign: 'right' }} />
        <div >
          <Table
            className='Table'
            scroll={{ x: '100%' }}
            columns={columns}
            dataSource={data}
            rowKey={record => record.id}
            pagination={{
              current: data.pageNum,
              pageSize: data.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: total => `共${total}条数据`,
              total: total
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>

        {
          deleteVisible &&
          <Modal
            title='删除站点'
            width={420}
            open={deleteVisible}
            onCancel={cancel}
            confirmLoading={loadBtn}
            onOk={deletes}>
            <div style={{ textAlign: 'center', color: "red" }}>
              <p>{`确定要删除角色【${rowParams.name}】吗？`}</p>
            </div>
          </Modal>
        }
        {
          <AddModel roleText={roleText} visible={editVisible} title={editTitle} formData={rowParams} cancel={(bool) => { setEditVisible(false); bool && listByRole() }} />
        }
      </div>
    </div >
  )
}

const mapStateToProps = state => {
  return {
    ...state.Common
  }
};

export default connect(mapStateToProps)(RoleCom)
